import { Grid, Typography } from '@mui/material';
import type { Currency, PlanInputFormFixedProduct } from '@vy/types';
import { PRICING_MODELS } from '@vy/types';
import { raise, withDefault } from '@vy/utils';
import { formatNumber } from '@vy/utils';
import React from 'react';
import { Price } from '../../../../../../components/design/Price';

type PromotionItemProps = {
  promotion: PlanInputFormFixedProduct;
  currency: Currency;
};

export const PromotionItem: React.FC<PromotionItemProps> = ({ promotion, currency }) => {
  return (
    <Grid component="li" container>
      <Grid size={6}>
        <Typography
          sx={{
            color: "#111B1E",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "16px"
          }}>
          {withDefault(promotion.name, '')}
        </Typography>
      </Grid>
      <Grid size={6} sx={{
        textAlign: "right"
      }}>
        <Typography
          sx={{
            color: "#9DA8AC",
            fontWeight: 300,
            fontSize: "12px",
            lineHeight: "16px"
          }}>
          Discount
        </Typography>
      </Grid>
      <Grid size={6}>
        <Typography
          sx={{
            color: "#94A0A4",
            fontWeight: 300,
            fontSize: "10px",
            lineHeight: "12px"
          }}>
          {withDefault(promotion.description, 'No Description')}
        </Typography>
      </Grid>
      <Grid size={6} sx={{
        textAlign: "right"
      }}>
        <Typography
          sx={{
            color: "#111B1E",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "16px"
          }}>
          {getPromotionPrice(promotion, currency)}
        </Typography>
      </Grid>
    </Grid>
  );
};

function getPromotionPrice(promotion: PlanInputFormFixedProduct, currency: Currency): React.ReactNode {
  if (promotion.variants[0].pricing.pricingModel === PRICING_MODELS.FixedDeduction) {
    return (
      <Price
        currency={currency}
        color="#111B1E"
        sx={{ fontWeight: 400, fontSize: '12px', lineHeight: '16px' }}
        align="right"
      >
        {-withDefault(promotion.variants[0].pricing.priceConfiguration?.amountToDeduct, 0)}
      </Price>
    );
  }

  if (promotion.variants[0].pricing.pricingModel === PRICING_MODELS.PercentageDeduction) {
    return (
      formatNumber(-withDefault(promotion.variants[0].pricing.priceConfiguration?.percentageToDeduct, 0), 2) +
      '%'
    );
  }

  return raise('Not implemented');
}
